import React from "react";
import Button from "../Button/Button";
import { Box, Typography } from "@mui/material";
function SocialButtons({sx, icon, text,imgStyle, onClick }) {
  return (
    <Button
      variant="outlined"
      sx={{
        width: "336px",
        height: "48px",
        "& p": {
          width: "100%",
        },
        ...sx
      }}
      outColor="#BFBFBF"
      onClick={onClick}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img src={icon} style={{ width: "24px", height: "24px",...imgStyle }} alt={"fb"} />
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            color: "text.primary",
          }}
        >
          {text}
        </Typography>
      </Box>
    </Button>
  );
}

export default SocialButtons;
